export default __webpack_public_path__ + "static/media/with_text.2b7c74b3.png";